function ProductsSidebarLoading(): JSX.Element {
  return (
    <div className="w-full container flex flex-col lg:order-2 lg:pl-4">
      <div className="pb-4">
        <div className="w-full border border-solid border-gray-200 rounded-lg">
          <div className="flex flex-col py-5 px-4 space-y-3">
            <div className="flex flex-row space-x-3">
              <div className="animate-pulse bg-gray-200 h-10 w-10 rounded"></div>
              <div className="animate-pulse bg-gray-200 h-10 w-40 rounded-lg"></div>
            </div>
            <div className="flex flex-row md:justify-between space-x-4">
              <div className="animate-pulse bg-gray-200 h-6 w-24 rounded-md"></div>
              <div className="animate-pulse bg-gray-200 h-6 w-36 rounded-lg"></div>
            </div>
            <div className="flex flex-row md:justify-between space-x-4">
              <div className="animate-pulse bg-gray-200 h-6 w-24 rounded-md"></div>
              <div className="animate-pulse bg-gray-200 h-6 w-36 rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-4">
        <div className="w-full border border-solid border-gray-200 rounded-lg">
          <div className="flex flex-col py-5 px-4 space-y-3">
            <div className="flex flex-row space-x-3">
              <div className="animate-pulse bg-gray-200 h-10 w-10 rounded"></div>
              <div className="animate-pulse bg-gray-200 h-10 w-40 rounded-lg"></div>
            </div>
            <div className="flex flex-row md:justify-between space-x-4">
              <div className="animate-pulse bg-gray-200 h-6 w-24 rounded-md"></div>
              <div className="animate-pulse bg-gray-200 h-6 w-36 rounded-lg"></div>
            </div>
            <div className="flex flex-row md:justify-between space-x-4">
              <div className="animate-pulse bg-gray-200 h-6 w-24 rounded-md"></div>
              <div className="animate-pulse bg-gray-200 h-6 w-36 rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full border border-solid border-gray-200 rounded-lg mb-8 lg:mb-0">
        <div className="p-6 flex flex-col space-y-3">
          <div className="flex flex-row space-x-3">
            <div className="animate-pulse bg-gray-200 h-10 w-10 rounded"></div>
            <div className="animate-pulse bg-gray-200 h-10 w-40 rounded-lg"></div>
          </div>
          <div className="flex flex-row space-x-4 justify-between w-full">
            <div className="animate-pulse w-full h-36  bg-gray-200 rounded-lg"></div>

            <div className="w-full flex flex-col space-y-2">
              <div className="animate-pulse bg-gray-200 h-4 w-30 rounded"></div>
              <div className="animate-pulse bg-gray-200 h-4 w-24 rounded"></div>
              <div className="animate-pulse bg-gray-200 h-4 w-16 rounded"></div>
              <div className="animate-pulse bg-gray-200 h-4 w-36 rounded"></div>
              <div className="animate-pulse bg-gray-200 h-4 w-20 rounded"></div>
              <div className="animate-pulse bg-gray-200 h-4 w-12 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductsSidebarLoading
